import React from 'react';
import MapContainer from './MapContainer';
import { OperationalZones } from '../../types/calculator';

interface DroneZoneMapOverlayProps {
  zones: OperationalZones;
  apiKey?: string;
  googleMapsApiKey?: string; // For backward compatibility
}

/**
 * DroneZoneMapOverlay Component
 * 
 * This component visualizes drone operational zones on Google Maps, 
 * displaying concentric circles with different colors for each zone.
 * 
 * @param {OperationalZones} zones - The calculated operational zones
 * @param {string} apiKey - Google Maps API key
 */
const DroneZoneMapOverlay: React.FC<DroneZoneMapOverlayProps> = ({ zones, apiKey, googleMapsApiKey }) => {
  // Use either apiKey or googleMapsApiKey (for backward compatibility)
  const mapsApiKey = apiKey || googleMapsApiKey || '';
  return (
    <div className="drone-zone-map-overlay">
      <MapContainer 
        zones={zones} 
        apiKey={mapsApiKey} 
      />
    </div>
  );
};

export default DroneZoneMapOverlay;
